// Import URL constants
import { CONTACTLISTING, DASHBOARD, NEWPURCHASE, NOTFOUND, PURCHASECREDITNOTE, REPORTS, SIMPLEPURCHASE, SUPPLIER, SUPPLIERLISTING } from "./constURL";

// Import components for each route
import Dashboard from '../Pages/Dashboard';
import Notfound from "../Pages/Notfound";
import SimplePurchase from "../Pages/Purchases/SimplePurchase";
import AddPurchase from "../Pages/Purchases/AddPurchase";
import ContactListing from "../Pages/Contacts/ContactListing";
import SupplierPage from "../Pages/Suppliers/SupplierPage";
import SupplierListing from "../Pages/Suppliers/SupplierListing/SupplierListing";
import ReportsPage from "../Pages/Reports/ReportsPage";
import PurchaseCreditNote from "../Pages/Purchases/PurchaseCreditNote/PurchaseCreditNote";

export const globalRoutes = [
  {
    path: DASHBOARD,
    element: Dashboard,
  },
  {
    path: SIMPLEPURCHASE,
    element: SimplePurchase,
  },
  {
    path: NEWPURCHASE,
    element: AddPurchase,
  },
  {
    path: SUPPLIER,
    element: SupplierPage
  },
  {
    path: SUPPLIERLISTING,
    element: SupplierListing
  },
  {
    path: CONTACTLISTING,
    element: ContactListing
  },
  {
    path: REPORTS,
    element: ReportsPage
  },
  {
    path: PURCHASECREDITNOTE,
    element: PurchaseCreditNote
  },
  {
    path: NOTFOUND,
    element: Notfound,
  },
];
